import { useSearchParams } from 'react-router-dom';
import SinglePageVariantOneLayout from 'packages/signup/components/layouts/singlePageVariantOne';

type BackgroundType = 'checkout' | 'single_page_variant_1';

export default function LayoutRedirect() {
  const [searchParams] = useSearchParams();

  const background = (searchParams.get('background') || 'default') as BackgroundType;

  if (background === 'single_page_variant_1') {
    return <SinglePageVariantOneLayout />;
  }

  return <SinglePageVariantOneLayout />;
}
